import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  active: attr(Boolean),
  employeeNumber: attr(String),
  firstName: attr(String),
  lastName: attr(String),
  token: attr(String),
  merchantToken: attr(String)
});